import ReactDOM from 'react-dom/client';
import { I18nextProvider } from 'react-i18next';
import { MsalProvider } from '@azure/msal-react';
import { AuthenticationResult, EventMessage, EventType } from '@azure/msal-browser';
import App from './App';
import i18n from './i18n';
import reportWebVitals from './reportWebVitals';
import StoreContextComponent from '@contexts/StoreContext';
import { msalInstance } from './auth/msalConfig';
// Registers the axios auth interceptors
import './api/http';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

// Mandatory before any MSAL API call with msal-browser v3+
msalInstance.initialize().then(() => {
    // MSAL never sets the active account by itself
    const accounts = msalInstance.getAllAccounts();
    if (!msalInstance.getActiveAccount() && accounts.length > 0) {
        msalInstance.setActiveAccount(accounts[0]);
    }

    msalInstance.addEventCallback((event: EventMessage) => {
        if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
            msalInstance.setActiveAccount((event.payload as AuthenticationResult).account);
        }
    });

    root.render(
        <MsalProvider instance={msalInstance}>
            <StoreContextComponent>
                <I18nextProvider i18n={i18n}>
                    <App />
                </I18nextProvider>
            </StoreContextComponent>
        </MsalProvider>,
    );
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
